export default __webpack_public_path__ + "static/media/schedulerImage.a781f5a2.jpg";